<div class="extra-area ptb-80">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="single-blog-post-box">
          <div class="entry-thumbnail">
            <img
              data-src="https://cdn.sanity.io/images/jizm7zxy/production/ea2ba39a00b4fc5aff7165adac875d37d94923ed-6720x4480.jpg?fm=webp"
              alt="image"
              data-sizes="auto"
              class="lazyload"
            />
          </div>
          <div class="entry-post-content">
            <div class="entry-meta"></div>
            <h3 i18n="@@downloadMediaKitTitle">Media kit</h3>
            <p i18n="@@downloadMediaKitDescription">Download our brand assets</p>
            <a href="https://cdn.sanity.io/files/jizm7zxy/production/cf19d10c33b4a21365917aff98703b1663296a8d.zip"
              ><span i18n="@@downloadWording">Download</span></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
